import React, { useContext } from 'react';
import './BottomBar.scss';
import getText from '../../assets/locale/locale';
import { LocaleContext } from '../../contexts';

const BottomBar = () => {
  const locId = useContext(LocaleContext);

  const handleCopyrightText = () => {
    const line = locId === 'en_US' ? 'copyrightParagraph' : 'line2';
    return getText(locId, 'AllPages', line, 'BottomBar').replace(
      '%CURRENT_YEAR%',
      new Date().getFullYear().toString()
    );
  };

  return (
    <footer role="contentinfo" id="footerBox" data-testid="jonesFooter">
      {locId === 'en_US' ? (
        <div className="footerContainer">
          <div className="links">
            <a
              href={getText(locId, 'AllPages', 'careersLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'careersText', 'BottomBar')}
            </a>
            <a
              href={getText(
                locId,
                'AllPages',
                'personalFinanceLink',
                'BottomBar'
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'personalFinanceText', 'BottomBar')}
            </a>
            <a
              href={getText(locId, 'AllPages', 'feedbackLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'feedbackText', 'BottomBar')}
            </a>
            <a
              href={getText(locId, 'AllPages', 'privacyLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'privacyText', 'BottomBar')}
            </a>
            <a
              href={getText(
                locId,
                'AllPages',
                'revenueSharingLink',
                'BottomBar'
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'revenueSharingText', 'BottomBar')}
            </a>
            <a
              href={getText(locId, 'AllPages', 'formCrsLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'formCrsText', 'BottomBar')}
            </a>
            <a
              href={getText(locId, 'AllPages', 'disclosuresLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'disclosuresText', 'BottomBar')}
            </a>
            <a
              href={getText(
                locId,
                'AllPages',
                'accessibilityLink',
                'BottomBar'
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'accessibilityText', 'BottomBar')}
            </a>
          </div>
          <div className="footerContent">
            <p>
              {handleCopyrightText()}
              <a
                title={getText(locId, 'AllPages', 'sipcText', 'BottomBar')}
                className="copyrightLink"
                target="_blank"
                rel="noopener noreferrer"
                href={getText(locId, 'AllPages', 'sipcLink', 'BottomBar')}
              >
                {getText(locId, 'AllPages', 'sipcText', 'BottomBar')}
              </a>
              .
              <br />
              {getText(locId, 'AllPages', 'disclaimerParagraph', 'BottomBar')}
            </p>
          </div>
        </div>
      ) : (
        <div className="footerContainer">
          <div className="links">
            <a
              href={getText(locId, 'AllPages', 'careersLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'careersText', 'BottomBar')}
            </a>
            <a
              href={getText(locId, 'AllPages', 'feedbackLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'feedbackText', 'BottomBar')}
            </a>
            <a
              href={getText(locId, 'AllPages', 'privacyLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'privacyText', 'BottomBar')}
            </a>
            <a
              href={getText(locId, 'AllPages', 'disclosuresLink', 'BottomBar')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'disclosuresText', 'BottomBar')}
            </a>
            <a
              href={getText(
                locId,
                'AllPages',
                'accessibilityLink',
                'BottomBar'
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'AllPages', 'accessibilityText', 'BottomBar')}
            </a>
          </div>
          <div className="footerContent">
            <p>
              {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
              {getText(locId, 'AllPages', 'member', 'BottomBar')}
              <a
                title={getText(locId, 'AllPages', 'CIPFText', 'BottomBar')}
                target="_blank"
                rel="noopener noreferrer"
                href={getText(locId, 'AllPages', 'CIPFLink', 'BottomBar')}
              >
                {getText(locId, 'AllPages', 'CIPFText', 'BottomBar')}
              </a>
              {getText(locId, 'AllPages', 'member2', 'BottomBar')}
              <a
                title={getText(locId, 'AllPages', 'IIROCText', 'BottomBar')}
                target="_blank"
                rel="noopener noreferrer"
                href={getText(locId, 'AllPages', 'IIROCLink', 'BottomBar')}
              >
                {getText(locId, 'AllPages', 'IIROCText', 'BottomBar')}
              </a>
              .
            </p>
            <p>{getText(locId, 'AllPages', 'line1', 'BottomBar')}</p>
            <p>{handleCopyrightText()}</p>
            <p>{getText(locId, 'AllPages', 'line3', 'BottomBar')}</p>
            <p>{getText(locId, 'AllPages', 'line4', 'BottomBar')}</p>
            <p>{getText(locId, 'AllPages', 'line5', 'BottomBar')}</p>
          </div>
        </div>
      )}
    </footer>
  );
};

export default BottomBar;
